import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import useAccessBlockStore from "../../store/useAccessBlockStore";

// While the subscription is expired the user must stay on the renewal screen, but these lanes are left
// reachable so they can actually renew or leave: the renewal screen itself, the İyzico hosted-checkout
// return (/subscription/success) and account subscription screens, and logout/login (whose logout thunk
// clears the block). Prefix match.
const SUBSCRIPTION_ALLOWED_PREFIXES = [
  "/subscription-expired",
  "/subscription",
  "/account/subscription",
  "/logout",
  "/login",
];

const OFFBOARDED_PATH = "/company-deactivated";

/**
 * Enforces the whole-tenant access block raised by the HTTP interceptor (see useAccessBlockStore).
 * Rendered above the route Switch so it can force navigation from anywhere:
 * - COMPANY_OFFBOARDED → the company-deactivated screen (locked out; paying does not help).
 * - SUBSCRIPTION_EXPIRED → the renewal screen, unless the user is already on a renewal/payment/auth lane.
 *
 * Returns null (renders nothing) when access is normal or the user is already on the correct screen, so
 * there is no redirect loop.
 */
const AccessBlockGuard: React.FC = () => {
  const block = useAccessBlockStore((s) => s.block);
  const location = useLocation();
  const path = location.pathname;

  if (block === "COMPANY_OFFBOARDED") {
    return path === OFFBOARDED_PATH ? null : <Redirect to={OFFBOARDED_PATH} />;
  }

  if (block === "SUBSCRIPTION_EXPIRED") {
    const allowed = SUBSCRIPTION_ALLOWED_PREFIXES.some((prefix) => path.startsWith(prefix));
    return allowed ? null : <Redirect to="/subscription-expired" />;
  }

  return null;
};

export default AccessBlockGuard;
